import React from "react";
import { Button, Dropdown, Input, MenuProps, Typography } from "antd";
import moment from "moment";
import { ChatUser } from "../../../../api/chat/chat-interface";

type Props = {
  conversation: any[];
  receiver: ChatUser | null;
  setMessage?: (value: string) => void;
  sendMessage: (content:string) => void;
};

function ImageElement({ src, alt = "", className = "" }: any) {
  return <img src={src} alt={alt} className={className} />;
}

function MessageArea({
  conversation,
  receiver,
  sendMessage,
}: Props) {
  // state
  const [message, setMessage] = React.useState("");

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: <ImageElement src="/img/vectors/messageimg.svg" />,
    },
    {
      key: "2",
      label: <ImageElement src="/img/vectors/messagedoc.svg" />,
    },
    {
      key: "3",
      label: <ImageElement src="/img/vectors/messagecontact.svg" />,
    },
  ];

  const lastMessageRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
   lastMessageRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [conversation]);


  return (
    <div className="relative flex flex-col justify-between pl-[3rem]">
      <div>
        <div className="flex items-center justify-center rounded-[20px] bg-appcolorgreyfainttwo py-[0.9rem]">
          <ImageElement
            src="/img/vectors/messagepp.svg"
            className="h-[2.1rem] w-[2.1rem] pr-[0.6rem]"
          />
          <Typography.Text className="text-[19px] font-medium leading-[23px] text-appcolorpurplefaintone">
            {receiver?.userName}
          </Typography.Text>
        </div>

        <div
          className="message-block mt-[2rem] flex h-80 flex-col"
        >
          {conversation.map((item, index) => {
            const chatClass =
              receiver?._id === item.creatorId ? "client-chat" : "my-chat";
            return (
              <div
                key={index}
                className={chatClass + " grid gap-1"}
                ref={
                  conversation[conversation.length - 1] === item
                    ? lastMessageRef
                    : null
                }
              >
                <p>{item.body}</p>
                <Typography.Text className="font-quicksand text-xs opacity-80">
                  {moment(item.dateSent).fromNow()}
                </Typography.Text>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex w-full items-center">
        <Dropdown menu={{ items }} placement="topRight">
          <ImageElement
            src="/img/vectors/filesmessage.svg"
            className="h-[3rem] cursor-pointer pr-[0.8rem]"
          />
        </Dropdown>

        <Input
          size="small"
          placeholder="Your Reply Here"
          bordered={false}
          className="custom-transparent-input-ai-message mr-4 w-full bg-appcolorgreyfainttwo"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onPressEnter={(e:any) => {sendMessage(e.target.value)
            setMessage('')
          }}
        />

        <Button
          className="!p-0"
          size="large"
          icon={
            <ImageElement
              src="/img/vectors/aireply.svg"
              className="h-full cursor-pointer"
            />
          }
          onClick={()=>{sendMessage(message)
            setMessage('')
          }}
        />
      </div>
    </div>
  );
}

export default MessageArea;
